import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "../api";
import { staticSite } from "../config";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (staticSite) { setLoading(false); return; }
    api.get("/auth/me").then(({ data }) => setUser(data.user)).catch(() => setUser(null)).finally(() => setLoading(false));
  }, []);

  const login = async (details, admin = false) => {
    const { data } = await api.post(admin ? "/auth/admin/login" : "/auth/login", details);
    setUser(data.user);
    return data.user;
  };
  const register = async (details) => {
    const { data } = await api.post("/auth/register", details);
    setUser(data.user);
    return data.user;
  };
  const logout = async () => { await api.post("/auth/logout"); setUser(null); };
  const updateProfile = async (details) => {
    const { data } = await api.put("/auth/me", details);
    setUser(data.user);
    return data.user;
  };

  const value = useMemo(() => ({ user, loading, login, register, logout, updateProfile }), [user, loading]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
